export const dns = 'https://digiapp.nrfsi.com',
// export const dns = 'https://digiappuat.nrfsi.com',
// export const dns = 'http://localhost:8081',

    baseUrl = `${dns}/nrfsi/renault/`, // prod
    // baseUrl = `${dns}/nrfsi/preprod/`, // preprod

    nissanUrl = `${dns}/Nissan_SFP`,
 
    preprodUrl = `${dns}/Renault_SFP`;

export const environment = {
    production: true,

    apiURL: {
        env: `${baseUrl}`,
        nUrl: `${nissanUrl}`,
        preUrl: `${preprodUrl}`,
        saveInfo: `${baseUrl}applicant/info`,
        saveIncome: `${baseUrl}applicant/income`,
        // saveLoan: `${baseUrl}finance/loan`,
        financialProductDetails: `${baseUrl}finance/details`,
        fetchVehicleDetails: `${baseUrl}asset/details/`,
        fetchQuotationStatus: `${baseUrl}quotation/status`,
        quoteCreation: `${baseUrl}asset/newQuote`,
        quoteUpdation: `${baseUrl}asset/changeQuote`,
        searchQuote: `${baseUrl}quotation/search`,
        generateOtp: `${baseUrl}applicant/consent`,
        sendOtp: `${baseUrl}applicant/consent/check`,
        resendOtp: `${baseUrl}applicant/consent/resend`,
        generateOtpToVerifyMobileEmail: `${baseUrl}applicant/consent/send/mobile/email`,
        sendOtpToVerifyMobileEmail: `${baseUrl}applicant/consent/check/mobile/email`,
        resendOtpToVerifyMobileEmail: `${baseUrl}applicant/consent/resend/mobile/email`,
        login: `${baseUrl}dlp/dealer/login`,
        fetchBackForm: `${baseUrl}`,
        addressDetails: `${baseUrl}locality/pincode`,
        dropdown: `${baseUrl}applicant/autofill`,
        financialProduct: `${baseUrl}financeService/financeproducts`,
        specialProgram: `${baseUrl}financeService/financeprograms`,
        loanStep1Post: `${baseUrl}finance/prodInfo`,
        loanStep2Post: `${baseUrl}finance/loan`, // to save the loan terms details + status
        refId: `${baseUrl}finance/loan/refid`, // to get the indus ref id
        emi: `${baseUrl}finance/loan/emi`,
        getSubventionDetails: `${baseUrl}finance/subvention/details`,
        subvention: `${baseUrl}finance/subvention`,
        subventionEmi: `${baseUrl}finance/subvention/emi`,
        subproductsEmi: `${baseUrl}finance/subproduct/emi`,
        subproducts: `${baseUrl}finance/subproducts`,
        changeCreation: `${baseUrl}asset/changeQuote`,
        loanReset: `${baseUrl}applicant/quotation`,
        preview: `${baseUrl}review/info/`,
        trackQuote: `${baseUrl}application/status/`,
        recentActivities: `${baseUrl}quotation/searchLastFive`,
        notification: `${baseUrl}notifications/preApproval`,
        deleteNotifiaction: `${baseUrl}notifications/updateReadStatus`,
        getFinanceDescription: `${baseUrl}financeService/selectedFinDet`,
        trackDistinct: `${baseUrl}quotation/track`, // for seach in track page
        approvalList: `${baseUrl}preapproval/status`,
        cityDealers: `${baseUrl}dlp/cityDealers`,
        usrDlrMap: `${baseUrl}dlp/usrDlrMap`,
        states: `${baseUrl}locality/states`,
        cities: `${baseUrl}locality/cities`,
        docsUpload: `${baseUrl}upload/doc`,
        fetchSzOrgTypeData: `${baseUrl}applicant/autofill/orgType`,
        fetchSzTypeOfBusinessData: `${baseUrl}applicant/autofill/typeOfBusiness`,
        validatePAN:  `${baseUrl}dlp/dealer/pan/validate`,


    }

};
